<template>
  <div class="header-content">
    <div class="header-left">
      <img
        class="header-logo"
        :src="
          logoIsBlack
            ? require('@/assets/images/header/logo-black.png')
            : require('@/assets/images/header/logo-white.png')
        "
      />
      <div class="header-nav">
        <div
          class="nav-item transition"
          :class="$route.path === '/' ? 'active' : ''"
          @click="handleNavClick({ expand4: '/' })"
        >
          {{ $t("nav.indexPage") }}
        </div>
        <div
          v-for="(item, index) in categoryTree.category"
          :key="index"
          class="nav-item transition"
          :class="isActive(item) ? 'active' : ''"
          @click="handleNavClick(item)"
        >
          {{ $t("ajaxKey") ? item[$t("ajaxKey")] : item.title }}
          <template v-if="item.children">
            <i class="el-icon-caret-bottom"></i>
            <div class="nav-menu">
              <div
                v-for="(childrenItem, childrenIndex) in item.children"
                :key="index + '_' + childrenIndex"
                class="menu-item transition"
                @click="handleNavClick(childrenItem)"
              >
                {{
                  $t("ajaxKey")
                    ? childrenItem[$t("ajaxKey")]
                    : childrenItem.title
                }}
              </div>
            </div>
          </template>
        </div>

        <div class="nav-item transition" @click="handleExternal">
          {{ $t("nav.externalLink") }}
        </div>
      </div>
    </div>
    <div class="header-right">
      <div
        v-for="(item, index) in langList"
        :key="index"
        class="lang-item transition"
        :class="item.value === locale ? 'active' : ''"
        @click="changeLang(item.value)"
      >
        <svg
          v-if="item.value === locale"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_84_3957)">
            <path
              d="M7.99993 0.0159912C5.88262 0.0159912 3.85203 0.85709 2.35487 2.35426C0.8577 3.85142 0.0166016 5.88201 0.0166016 7.99932C0.0166016 10.1166 0.8577 12.1472 2.35487 13.6444C3.85203 15.1416 5.88262 15.9827 7.99993 15.9827C10.1172 15.9827 12.1478 15.1416 13.645 13.6444C15.1422 12.1472 15.9833 10.1166 15.9833 7.99932C15.9833 5.88201 15.1422 3.85142 13.645 2.35426C12.1478 0.85709 10.1172 0.0159912 7.99993 0.0159912ZM14.0986 5.33866C14.4546 6.15332 14.6533 7.05332 14.6533 7.99999C14.6533 8.94666 14.4546 9.84666 14.0986 10.6613H11.0986C11.2453 9.83599 11.3253 8.93866 11.3253 7.99999C11.3253 7.06132 11.2453 6.16399 11.0986 5.33866H14.0986ZM6.00527 7.99999C6.00527 7.04399 6.0786 6.13999 6.21193 5.33866H9.7866C9.91994 6.13999 9.9946 7.04399 9.9946 7.99999C9.9946 8.95599 9.91994 9.85999 9.7866 10.6613H6.21327C6.07993 9.85999 6.00527 8.95599 6.00527 7.99999ZM13.3226 4.00799H10.7893C10.4799 2.96932 10.0559 2.11466 9.55593 1.53066C11.0614 1.89324 12.3934 2.76928 13.3226 4.00799ZM7.99993 2.01332C8.5906 2.01332 9.1226 2.78532 9.48794 4.00932H6.51193C6.87727 2.78399 7.40927 2.01332 7.99993 2.01332ZM6.44393 1.53199C5.94393 2.11466 5.51993 2.97199 5.21193 4.00932H2.6786C3.6075 2.77087 4.93896 1.89485 6.44393 1.53199ZM1.90127 5.33866H4.90127C4.7546 6.16399 4.6746 7.06132 4.6746 7.99999C4.6746 8.93866 4.7546 9.83599 4.90127 10.6613H1.90127C1.53452 9.82205 1.34566 8.91589 1.3466 7.99999C1.3466 7.05332 1.54527 6.15332 1.90127 5.33866ZM2.67727 11.992H5.2106C5.51993 13.0307 5.94393 13.8853 6.44393 14.4693C4.93847 14.1067 3.6065 13.2307 2.67727 11.992ZM7.99993 13.9867C7.40927 13.9867 6.87727 13.2147 6.51193 11.9907H9.48794C9.11994 13.216 8.5906 13.9867 7.99993 13.9867ZM9.55593 14.468C10.0559 13.8853 10.4799 13.028 10.7879 11.9907H13.3213C12.3924 13.2291 11.0609 14.1051 9.55593 14.468Z"
              fill="#008177"
            />
          </g>
          <defs>
            <clipPath id="clip0_84_3957">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { categoryTree as getCategoryTree } from "@/api/common";
import { categoryTree } from "@/store";
import { getStore, setStore } from "@/utils/store";
export default {
  props: {
    logoIsBlack: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locale: getStore({ name: "language" }) || "zh",
      langList: [
        {
          label: "中文",
          value: "zh",
        },
        {
          label: "English",
          value: "en",
        },
        {
          label: "日本語",
          value: "ja",
        },
        {
          label: "한국어",
          value: "ko",
        },
      ],
      categoryTree,
    };
  },
  computed: {
    isActive() {
      return (item) => {
        if (!item.children) {
          return item.expand4.indexOf(this.$route.meta.key) !== -1;
        } else {
          return item.children.some(
            (row) =>
              row.expand4 && row.expand4.indexOf(this.$route.meta.key) !== -1
          );
        }
      };
    },
  },
  created() {
    getCategoryTree().then((res) => {
      this.categoryTree.set_category(res.data);
    });
  },
  methods: {
    changeLang(key) {
      this.$i18n.locale = key;
      this.locale = key;
      setStore({
        name: "language",
        content: key,
      });
      window.location.reload();
    },
    handleNavClick(item) {
      if (item.children) return;
      if (item.expand4) this.$router.push(item.expand4);
    },
    handleExternal() {
      window.open("http://www.zjjslf.com/");
    },
  },
};
</script>

<style lang="scss" scoped>
.header-content {
  width: 100%;
  min-width: 1650px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 88px;
  padding: 0 40px;
  position: absolute;
  z-index: 3;
  .header-left,
  .header-right {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .header-logo {
    display: block;
    height: 50px;
    margin-right: 48px;
  }
  .header-nav {
    display: flex;
    color: #000;
    font-size: 16px;
    font-weight: 400;
    height: 100%;
    .nav-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 140px;
      height: 100%;
      position: relative;

      text-align: center;
      cursor: pointer;
      color: #ffffff;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        right: 50%;
        top: 0;
        background: #008177;
        height: 3px;
        transition-property: left, right;
        transition-duration: 0.3s;
        transition-timing-function: ease-out;
      }
      i {
        margin-left: 8px;
      }
      .nav-menu {
        position: absolute;
        width: 100%;
        bottom: 0;
        background: #ffffff;
        color: #000000;
        box-sizing: border-box;
        transform: translate(0px, 100%);
        z-index: 3;
        display: none;

        .menu-item {
          text-align: center;
          padding: 10px;
          color: #222;
          font-size: 16px;
          line-height: 21px;
          font-weight: 400;
          cursor: pointer;

          &:hover {
            background: #009d94;
            color: #ffffff;
          }
        }
      }

      &.active {
        // border-bottom: 4px solid #fff;
        box-shadow: inset 0px -4px 0 0px #ffffff;
      }
      &:hover {
        background: rgba(0, 0, 0, 0.7);
        &::before {
          left: 0;
          right: 0;
        }
        .nav-menu {
          display: block;
        }
      }
    }
  }
  .lang-item {
    color: #ffffff;
    font-size: 15px;
    font-weight: 400;

    cursor: pointer;
    display: flex;
    align-items: center;
    svg {
      margin-right: 6px;
    }
    &:hover,
    &.active {
      color: #008177;
    }
    + .lang-item {
      margin-left: 16px;
    }
  }
}
</style>
